import { useQuery } from '@tanstack/react-query';

import { getCollections } from '~/services/ExperiencesService';

import { experiencesQueryKeys } from './experiencesQueryKeys';

export function useGetCollections(onlyActive = false) {
  return useQuery({
    queryKey: experiencesQueryKeys.collectionsList(onlyActive),
    queryFn: () => getCollections(onlyActive),
  });
}
